import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { IvrgatewayService } from '../../../../../common/services/Ivrgateway.service';


declare var $: any;

@Component({
    moduleId: module.id,
    selector: "gateway",
    templateUrl: './ivrgateway.component.html',
    styleUrls: ['./gateway.css'],
    providers: [IvrgatewayService, BsModalService]
})

@Injectable()
export class IvrgatewayComponent implements OnInit {
    public dtOptions: any = {};
    public dtTrigger: Subject<any> = new Subject();

    public currentPage: number = 1;
    public totalRow: number = 0;
    public page_size: number = 10;
    public message: { class: string, content: string } = null;
    public list : any = [];
    public model: any = {};
    public typeModal : string;
    public modalRef: any = {};
    public modalRef2: any = {};
    public types : any = [];
    totalItem: any = 0;
    totalPage: any = 0;
    public modelFilter: any = {};

    public id_delete : number;
    public user: any = {};


    constructor(
        private ivrgatewayService : IvrgatewayService,
        private modalService : BsModalService,
        private toastr: ToastrService) {
            this.user = JSON.parse(localStorage.getItem('User'));
    }

    ngOnInit() {
        this.types=[{
            id: 3,
            text: 'IVR'
        },{
            id: 1,
            text: 'ACD'
        },{
            id: 0,
            text: 'Outbound'
        }];
       this.loadData()
    }


    
    loadData(request: any = {}, sort: any = {}) {
        this.list = [];
        request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }

        this.ivrgatewayService.list(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                this.list = res.data.ivrgateways;
                this.totalItem = res.data.total;
                var pageString = (this.totalItem / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage = totalpage;


            } else {
                this.message = {
                    class: "alert dark alert-danger",
                    content: res.status + ' : ' + res.message
                };
                this.list = [];
                // this.genDataTable();
                this.scrollToTop();
            }

        }, err => {
            this.message = {
                class: "alert dark alert-danger",
                content: err.message
            };
            this.list = [];
            // this.genDataTable();
            this.scrollToTop();
        });
    }

    search() {
        this.currentPage = 1;
        if(this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
            this.loadData({sipurl: this.modelFilter.keyword});
        }else this.loadData();
    }

    scrollToTop() {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    }

    openModal(template: TemplateRef<any>, id?:any) {
        this.message = null;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(template, config);
        
        this.model = {};
        this.typeModal  = id ? 'edit' : 'add'
        console.log(id);
        if(id) {
            this.ivrgatewayService.find(id).toPromise().then(rs => {
                console.log(rs);
                this.model = {
                    ivrgateway_id: rs.data.ivrgateway_id,
                    line: rs.data.line,
                    url : rs.data.sipurl,
                    type : rs.data.type,
                    description :rs.data.description
                }

            })
        }
    }

    add() {
        if(!this.model.type)
            this.message = { class: "alert dark alert-danger", content: "Loại không được bỏ trống !" };
        else if(!this.model.line || (this.model.line && this.model.line.trim() == ""))
            this.message = { class: "alert dark alert-danger", content: "Đầu số không được bỏ trống !" };
        else if(!this.model.url || (this.model.url && this.model.url.trim() == ""))
            this.message = { class: "alert dark alert-danger", content: "Url không được bỏ trống !" };
        else {
            let payload = {
                LINE: this.model.line,
                SIPURL:this.model.url,
                DESCRIPTION: this.model.description,
                TYPE : this.model.type 
            }
            this.ivrgatewayService.create(payload).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                        this.toastr.error('Thêm mới thất bại', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.message = { class: "alert dark alert-success", content: "Thêm mới thành công" };
                        this.toastr.success('Thêm mới thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        
                        this.loadData();
                        this.modalRef.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        }
    }

    edit(data) {
        this.message = null;
        if(!this.model.type)
            this.message = { class: "alert dark alert-danger", content: "Loại không được bỏ trống !" };
        else if(!this.model.line || (this.model.line && this.model.line.trim() == ""))
            this.message = { class: "alert dark alert-danger", content: "Đầu số không được bỏ trống !" };
        else if(!this.model.url || (this.model.url && this.model.url.trim() == ""))
            this.message = { class: "alert dark alert-danger", content: "Url không được bỏ trống !" };
        else {
            let payload = {};
            if(this.model.line) payload['LINE'] = this.model.line;
            if(this.model.url) payload['SIPURL'] = this.model.url;
            if(this.model.description) payload['DESCRIPTION'] = this.model.description;
            if(this.model.type) payload['TYPE'] = this.model.type;
            this.ivrgatewayService.update(this.model.ivrgateway_id, payload).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Cập nhật không thành công" };
                        this.toastr.error('Cập nhật thất bại', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.message = { class: "alert dark alert-success", content: "Cập nhật thành công" };
                        this.toastr.success('Cập nhật thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.loadData();
                        this.modalRef.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        }
        this.scrollToTop();
    }


    public changeType(e: any): void {
        this.model.type = e.value
    }

    openConfirmDelete(template: TemplateRef<any>, id) {
        this.id_delete = id;
        // this.modalRef2 = this.modalService.show(template);
        var y = confirm("Bạn có muốn xóa không?");
        if(y){
            this.submitDelete();
        }
    }

    submitDelete() {
        this.ivrgatewayService._delete(this.id_delete).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.message = { class: "alert dark alert-danger", content: "Xóa không thành công" };
                    this.toastr.error('Xóa không thành công', error.message, {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.message = { class: "alert dark alert-success", content: "Xóa thành công" };
                    this.toastr.success('Xóa thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    this.loadData();
                    // this.modalRef2.hide();
                }
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
            this.toastr.error('Xóa không thành công', error.message, {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            // this.modalRef2.hide();
        });
    }

    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.loadData();
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.loadData();
                }
            }
        }
    }

    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }

    _keyPress(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }

}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/gateway/ivrgateway.component.ts